import React, { useState, useEffect, useRef } from "react";
import FooterUtente, { infoUtente, loadFooter } from "../../visualComponents/FooterUtente";
import { Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import jsQR from "jsqr";
import Loader from "../../visualComponents/Loader.js";
import NavBar from "../../visualComponents/NavBarGenerale.js";

let isLoading = false;

const CreaComponenteUtente = () => {
    const [selectTipologia, setSelectTipologia] = useState(null);
    const [data, setData] = useState(null);
    const [codice, setCodice] = useState("");
    const [tipologia, setTipologia] = useState("");
    const [dataInstallazione, setDataInstallazione] = useState("");
    const [descrizione, setDescrizione] = useState("");
    const [scanning, setScanning] = useState(false);
    const [id, setId] = useState(null);
    const canvasRef = useRef(null);
    const inputRefs = useRef([]);

    const navigate = useNavigate();

    useEffect(() => {
        onload();
    }, []);

    const onload = async () => {
        try {
            isLoading = true;

            await loadFooter();

            const r3 = await fetch('/getTipologie', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"]
                })
            });
            const rd3 = await r3.json();
            // console.log(rd3);
            if (r3.status === 500) {
                alert(rd3.error);
                console.error(rd3.error);
                navigate('/dashUtente/componenti');
            } else {
                setSelectTipologia(rd3.filter((d) => d["Obsoleto"] === false));

                if (document.cookie.split("IDComponente=").length > 1) {
                    const r4 = await fetch('/getComponente', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            CodiceDominio: infoUtente["CodiceDominio"],
                            ID: document.cookie.split("IDComponente=")[1].split(";")[0]
                        })
                    });
                    const rd4 = await r4.json();
                    if (r4.status === 500) {
                        alert(rd4.error);
                        console.error(rd4.error);
                        navigate('/dashUtente/componenti');
                    } else {
                        isLoading = false;
                        setData(rd4[0]);
                        setCodice(rd4[0]["Codice"]);
                        setTipologia(rd4[0]["CodiceTipologia"]);
                        setDataInstallazione(rd4[0]["DataInstallazione"].split('/')[2] + "-" + rd4[0]["DataInstallazione"].split('/')[1] + "-" + rd4[0]["DataInstallazione"].split('/')[0]);
                        setDescrizione(rd4[0]["Descrizione"]);
                        setId(rd4[0]["ID"]);
                        //rimuovi il cokie
                        document.cookie = "IDComponente=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                    }
                }
                else {
                    isLoading = false;
                }
            }
        } catch (error) {
            alert("Errore durante il caricamento della pagina, riprovare più tadi");
            console.log(error);
            navigate('/dashUtente/componenti');
        }

    };

    const handleScanCode = async () => {
        const newScanning = !scanning;
        setScanning(newScanning);
        if (newScanning) {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        facingMode: { ideal: 'environment' }
                    }
                });
                const video = document.querySelector('video#scan');
                video.srcObject = stream;
                video.removeAttribute('hidden');
                setScanning(true);
                setId(null);

                requestAnimationFrame(detectQRCode);
            } catch (error) {
                alert("Errore nella lettura");
                console.log(error);
                window.location.reload();
            }
        }
        else {
            handleStopScan();
        }
    };

    const detectQRCode = async () => {
        const video = document.querySelector('video#scan');
        const canvas = canvasRef.current;
        try {
            const ctx = canvas.getContext('2d');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            try {
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const code = jsQR(imageData.data, imageData.width, imageData.height);
                if (code) {
                    const tracks = video.srcObject?.getTracks();
                    tracks?.forEach(track => track.stop());
                    setScanning(false);
                    scanSuccess(code.data);
                } else {
                    requestAnimationFrame(detectQRCode);
                }
            } catch (error) {
                console.log(error);
                requestAnimationFrame(detectQRCode);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleStopScan = () => {
        const video = document.querySelector('video#scan');
        const stream = video.srcObject;
        const tracks = stream.getTracks();

        tracks.forEach(function (track) {
            track.stop();
        });

    };

    const scanSuccess = async (qrCode) => {
        try {
            isLoading = true;
            const response = await fetch('/checkCodiceQr', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceQr: qrCode
                })
            });
            const data = await response.json();

            if (response.status !== 200) {
                alert(data.error);
                console.error(data.error);
                window.location.reload();
            } else {
                isLoading = false;
                setId(qrCode);
            }

        } catch (error) {
            alert("Errore durante la scansione del codice QR");
            console.log(error);
            window.location.reload();
        }
    };

    const handleImport = () => {
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.accept = ".csv";
        fileInput.click();
        fileInput.onchange = (event) => {
            const file = event.target.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = function (event) {
                const text = event.target.result;
                const rows = text.split("\n").map(row => row.split(",").map(cell => cell.replace(/"/g, "")));
                if (rows.length < 2) {
                    alert("File non valido");
                    return;
                }
                rows.shift();
                const data = rows[0][0].split(";");
                setCodice(data[0]);
                setTipologia(data[1]);
                setDataInstallazione(data[2]);
                setDescrizione(data[3]);
            };
            reader.onerror = function () {
                console.error("Errore durante la lettura del file CSV");
            };

            reader.readAsText(file);
        }
    };

    const handleExport = () => {
        if (tipologia === "" || dataInstallazione === "") {
            alert("Compilare tutti i campi");
            return;
        }

        const data = [
            ["Codice", "Tipologia", "Data Installazione", "Descrizione"],
            [codice, tipologia, dataInstallazione, descrizione]
        ];
        const filename = "Export_componente.csv";

        // Crea il contenuto del CSV
        const csvContent = data
            .map(row => row.map(cell => `"${cell}"`).join(";"))
            .join("\n"); // Unisci le righe con newline

        // Crea un blob con il contenuto CSV
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

        // Crea un link per scaricare il file
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute("download", filename);

        // Aggiungi e clicca il link per forzare il download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleAnnulla = () => {
        if (scanning) handleStopScan();
        navigate('/dashUtente/componenti');
    };

    const handleConferma = async () => {
        if (tipologia === "" || dataInstallazione === "" || id === null) {
            alert("Compilare tutti i campi");
            return;
        }

        if (data) { //modifica
            try {
                isLoading = true;
                const r1 = await fetch("/aggiornaComponente", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente["CodiceDominio"],
                        ID: id,
                        Codice: codice,
                        CodiceTipologia: tipologia,
                        DataInstallazione: dataInstallazione,
                        Descrizione: descrizione
                    }),
                });
                if (r1.status === 500) {
                    const rd1 = await r1.json();
                    alert(rd1.error);
                    console.log(rd1.error);
                    window.location.reload();
                } else {
                    isLoading = false;
                    navigate('/dashUtente/componenti');
                }

            } catch (error) {
                alert("Errore durante la modifica del componente, riprova più tardi");
                console.log(error);
                window.location.reload();
            }

        } else { //aggiunta
            try {
                isLoading = true;
                const r1 = await fetch("/addComponente", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente["CodiceDominio"],
                        ID: id,
                        IDAzienda: document.cookie.split("IDAzienda=")[1].split(";")[0],
                        Codice: codice,
                        CodiceTipologia: tipologia,
                        DataInstallazione: dataInstallazione,
                        Descrizione: descrizione
                    }),
                });
                if (r1.status === 500) {
                    const rd1 = await r1.json();
                    alert(rd1.error);
                    console.log(rd1.error);
                } else {
                    navigate('/dashUtente/componenti');
                }
            } catch (error) {
                alert("Errore durante l'aggiunta del componente");
                console.log(error);
                window.location.reload();
            }
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Evita il comportamento predefinito del form
            const nextInput = inputRefs.current[index + 1];
            if (nextInput) {
                nextInput.focus(); // Passa al campo successivo
            }
        }
    };

    return (
        <div className="min-h-screen bg-white dark:bg-gray-800">
            <NavBar page="COMPONENTE" />
            {isLoading && <Loader />}
            <div className="bg-white dark:bg-gray-800 text-black dark:text-white mb-20 pt-[4rem]">
                <p className="font-bold text-xl justify-self-center mb-3 text-center">{data ? "MODIFICA COMPONENTE" : "CREA COMPONENTE"}</p>
                <div className='grid grid-cols-2 gap-2'>
                    <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={handleImport}>
                        IMPORT
                    </button>
                    <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={handleExport}>
                        EXPORT
                    </button>
                </div>
                <div className="grid grid-cols-2 mx-5 mb-4 mt-8">
                    <p className="">Codice (opz): </p>
                    <input 
                    type="text" 
                    className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-1" 
                    value={codice} 
                    onChange={(e) => setCodice(e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, 0)}
                    ref={el => inputRefs.current[0] = el}
                    ></input>
                </div>
                <div className="grid grid-cols-2 mx-5 mb-4">
                    <p className="">Tipologia: </p>
                    <select 
                    className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-1" 
                    value={tipologia} 
                    onChange={(e) => setTipologia(e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, 1)}
                    ref={el => inputRefs.current[1] = el}
                    >
                        <option value='' className="text-center">-----</option>
                        {
                            selectTipologia && selectTipologia.map((d, index) => (
                                <option key={index} value={d["Codice"]}>{d["Descrizione"]}</option>
                            ))
                        }
                    </select>
                </div>
                <div className="grid grid-cols-2 mx-5 mb-4">
                    <p className="">Data Installazione: </p>
                    <input 
                    type="date" 
                    className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-1" 
                    value={dataInstallazione} 
                    onChange={(e) => setDataInstallazione(e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, 2)}
                    ref={el => inputRefs.current[2] = el}
                    ></input>
                </div>
                <div className="grid grid-cols-2 mx-5 mb-4">
                    <p className="">Descrizione (opz): </p>
                    <input 
                    type="text"
                    className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-1" 
                    value={descrizione} 
                    onChange={(e) => setDescrizione(e.target.value)}
                    onKeyDown={(e) => handleKeyDown(e, 3)}
                    ref={el => inputRefs.current[3] = el}
                    ></input>
                </div>
                <div className="grid grid-cols-2 mx-5 mb-4 items-center">
                    <p className="">Codice QR: </p>
                    <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={handleScanCode} disabled={id !== null}>
                        {scanning ? "STOP SCAN" : "SCAN QR"}
                    </button>
                </div>
                <div className="flex justify-center items-center mt-4">
                    {scanning ? (
                        <>
                            <video muted autoPlay playsInline hidden width="70%" height="70%" id="scan" className="rounded"></video>
                            <canvas
                                ref={canvasRef}
                                style={{ display: 'none' }}
                                hidden
                            />
                        </>
                    ) : (
                        id ? (
                            <div className="flex justify-center items-center text-green-500">
                                <Check size={24} />
                                <p className="ml-2">Codice QR rilevato con successo</p>
                            </div>
                        ) : (
                            <div className="flex justify-center items-center text-red-500">
                                <p>Nessun codice rilevato</p>
                            </div>
                        )
                    )
                    }
                </div>
                <div className='grid grid-cols-2 gap-2'>
                    <button className="bg-red-500  text-white font-bold py-2 px-4 rounded mt-4" onClick={handleAnnulla}>
                        ANNULLA
                    </button>
                    <button className="bg-green-500  text-white font-bold py-2 px-4 rounded mt-4" onClick={handleConferma}>
                        CONFERMA
                    </button>
                </div>
            </div>
            <FooterUtente />
        </div >
    );
};

export default CreaComponenteUtente;